import { z } from 'zod'
import { Id, Timestamp } from './common'

export const ServiceRecord = z.object({
  id: Id,
  bike_id: Id,
  job_id: Id.nullable(),
  job_title: z.string().nullable(),
  performed_at: Timestamp,
  description: z.string(),
  cost_minor: z.number().int().nullable(),
  currency: z.string().nullable(),
  components: z.array(z.object({ id: Id, category: z.string(), name: z.string() })),
  created_at: Timestamp,
})
export type ServiceRecord = z.infer<typeof ServiceRecord>

export const ServiceRecordList = z.object({ records: z.array(ServiceRecord) })
export type ServiceRecordList = z.infer<typeof ServiceRecordList>

export const CreateServiceRecordBody = z.object({
  bike_id: Id,
  performed_at: Timestamp,
  description: z.string().trim().min(1, 'Say what was done.').max(4000),
  cost_minor: z.number().int().min(0).max(100_000_000).nullable().optional(),
  currency: z
    .string()
    .regex(/^[A-Z]{3}$/)
    .default('GBP'),
  component_ids: z.array(Id).max(50).default([]),
  /** Service intervals this work resets, at `performed_at`. */
  reset_interval_ids: z.array(Id).max(50).default([]),
})
export type CreateServiceRecordBody = z.input<typeof CreateServiceRecordBody>

export const UpdateServiceRecordBody = CreateServiceRecordBody.omit({ bike_id: true })
  .partial()
  .refine((b) => Object.keys(b).length > 0, 'Nothing to update.')
export type UpdateServiceRecordBody = z.input<typeof UpdateServiceRecordBody>

export const ServiceRecordListQuery = z.object({
  bike_id: Id.optional(),
  component_id: Id.optional(),
})
